export class ViewQuery {
    public readonly query: any;

    constructor(
        public readonly name: string,
        params: string[]
    ) {
        if (params?.length) {
            if (params.length > 0) {
                this.query = {};

                for (let i = 0; i < params.length; i+=2) {
                    this.query[params[i]] = i + 2 <= params.length ? params[i + 1] : undefined;
                }
            }
        }
    }
}
